'use strict';

wbApp.directive('wbRegistrationAlert', ['notificationSvc','$window', 'tenantSettingSvc', '$modal',
    function (notificationSvc, $window, tenantSettingSvc, $modal) {
        return {
            restrict: 'A',
            priority: 1,
            scope: { },
            template:
                "<div class='registration-alert registration-alert-min' ng-class='{\"registration-alert-min\": minimized, \"registration-alert-advertised\": advertised }'><div style='position:relative;'>" +
                    "<div class='message-panel'><h1>{{'TXT_LBL_WHO_ARE_YOU' | translate}}</h1><p>{{'TXT_LBL_LOGIN_REQUIRED' | translate}}</p></div>" +
                    "<div class='close-panel' ng-click='onActionPanelClick()'>" +
                        "<i ng-hide='minimized' class='fa fa-lg fa-chevron-left'></i>" +
                        "<i ng-show='minimized' class='fa fa-lg fa-chevron-right'></i>" +
                    "</div>" +
                    "<div class='action-button' style='top: 0; padding-top: 20px;'><button class='btn btn-lg btn-success' ng-click='onLoginClick()' >{{'TXT_BTN_LOGIN'|translate}}</button></div>" +
                    "<div ng-if='enableUserRegistration' class='action-button' style='top: 75px; padding-top: 10px;' ><a href='/MyAccount/?tabName=user-account&registration=true&returnUrl={{returnUrl}}' class='btn btn-lg btn-warning'>{{'TXT_LBL_NEW_ACCOUNT' | translate}}</a></div>" +
                "</div></div>",
            link: function (scope, element, attr, ctrl) {
                scope.minimized = true;
                scope.minClicked = false;
                scope.enableUserRegistration = tenantSettingSvc.settings.enableUserRegistration;

                scope.returnUrl = "";
                scope.onActionPanelClick = function (urlParams) {
                    scope.advertised = !scope.advertised;
                    scope.minimized = !scope.advertised;

                    if (!!urlParams) {
                        scope.returnUrl = encodeURIComponent(location.pathname + location.search);
                    }
                }
                
                scope.onLoginClick = function() {
                    scope.advertised = !scope.advertised;
                    scope.minimized = !scope.advertised;
                    signInDialogPromise.$promise.then(function () {
                        signInDialogPromise.show();
                    });                    
                }

                notificationSvc.registerAdvertiseCallback(scope.onActionPanelClick);

                let signInDialogPromise = $modal({
                    templateUrl: 'sign-in/sign-in-dialog.html',
                    show: false,
                    scope: scope.$new(true)
                });
            }
        }
    }]);